import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '로딩 중입니다...',
  sx: {},
};

const LoadingSlice = createSlice({
  name: 'Loading',
  initialState,
  reducers: {
    showLoading: (state) => {
      state.open = true;
    },
    closeLoading: (state) => {
      state.open = false;
    },
  },
});

export const { showLoading, closeLoading } = LoadingSlice.actions;
export default LoadingSlice.reducer;
